<template>
  <nav class="secretary-menu">
    <div
      class="secretary-menu__doctor"
      @click.stop.prevent="isListVisible = !isListVisible"
    >
      <img
        :src="doctor['profile_picture']"
        class="secretary-menu__doctor-img"
      />

      <p class="secretary-menu__doctor-txt">
        Você está administrando
      </p>

      <p class="secretary-menu__doctor-txt">
        <strong>
          {{ doctor.user.name }}
        </strong>

        <i v-if="doctorList.length > 0" class="icon icon-caret" />
      </p>
    </div>

    <transition name="fade_up">
      <ul
        v-if="isListVisible"
        v-click-outside="() => isListVisible = false"
        class="secretary-menu__list"
      >
        <li
          v-for="doctor in doctorList"
          :key="`doctorList-doctor-${doctor.id}`"
          @click.stop.prevent="$router.push({ path: `/secretary/doctor/${doctor.id}` })"
          class="secretary-menu__list-item"
        >
          <img
            :src="getDoctorProfilePicture(doctor)"
            class="secretary-menu__list-item-img"
          />

          <p class="secretary-menu__list-item-txt">
            Alternar para
          </p>

          <p class="secretary-menu__list-item-txt">
            <strong>{{ doctor.user.name }}</strong>
          </p>
        </li>
      </ul>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'secretaryMenu',

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    },

    doctorList: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data () {
    return {
      isListVisible: false
    }
  },

  methods: {
    getDoctorProfilePicture (doctor) {
      return `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`
    }
  }
}
</script>
